import styled from 'styled-components'

export const TableButtonWrapper = styled.div<{ disabled?: boolean }>`
  display: flex;
  justify-content: space-between;

  button {
    margin-left: 10px;
    font-size: 20px;
    border: none;
    background: none;
    cursor: pointer;
    opacity: ${({ disabled }) => (disabled ? '0.5' : '1')};
    transition: all 0.5s ease 0s;
  }
`
